import React, { createContext } from 'react';

export const ShoppingStart = createContext();
